import {type GameDataFirstGameState} from '@colonist/game-state-types'
import {GameStateEnums, type NetworkEnums} from '../../../shared/GameEnums.ts'
import {type SocketDataTypes} from '../../../shared/SocketDataTypes.ts'
import {SocketActionController} from '../../shared/scripts/socket/SocketActionController.ts'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend.ts'
import {type UIGameManager} from '../../shared/scripts/ui_game/UIGameManager.ts'
import {type UIManager} from './ui_html/UIManager.ts'
import {Scene} from './ui_html/UISceneTypes.ts'
import {UIUrlController} from '../../shared/scripts/ui_html/UIUrlController.ts'
import {UIPopupFunnelIncentiveController} from './ui_popup/UIPopupFunnelIncentiveController.ts'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {type MatchmakingStatusUpdate} from '../../../shared/matchmaking/MatchmakingInterfaces.ts'
import {UIAdBlockController} from './ui_ad/UIAdBlockController.ts'
import {UIRoomController} from './ui_html/room/UIRoomController.ts'
import {type BaseError} from '../../../shared/errors/BaseError.ts'
import {type FeedMessageData} from '@colonist/shared-types'
import {type UIWGeneralServicesController} from './UIWGeneralServicesController.ts'
import {setGlobalGameEndNumberOfPlayersJoinedRematch} from '@colonist/ui-game'
import {showMatchmakingErrorPopup} from '../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts'

export class SocketWebActionController extends SocketActionController {
    readonly uiGameManager: UIGameManager | undefined
    protected readonly uiManager: UIManager | undefined
    private hasDisplayedLoginIncentive: boolean = false

    constructor(uiGameManager: UIGameManager | undefined, uiManager: UIManager | undefined, generalServicesController: UIWGeneralServicesController) {
        super(generalServicesController)
        this.uiGameManager = uiGameManager
        this.uiManager = uiManager
    }

    // eslint-disable-next-line class-methods-use-this
    onChatText(chatData: FeedMessageData) {
        return
    }

    onStateSessionState() {
        const isAdblockActive = this.uiManager?.adController.adblockState.isAdblockActive ?? false
        SocketLobbySend.setAdBlockStatusToUserSession(isAdblockActive)

        const accessGameFromLink = UIUrlController.getRoomIdFromUrl() !== undefined

        if(!this.hasDisplayedLoginIncentive) UIPopupFunnelIncentiveController.showPopup(accessGameFromLink)
        this.hasDisplayedLoginIncentive = true
    }

    onConnectionEstablished(data: GameDataFirstGameState) {
        this.uiManager?.sceneController.loadScene(Scene.Game)
        UIRoomController.updateURLToRoom(data.gameSettingId)
    }

    onStateInitialPlacement() {
        this.uiManager?.sceneController.loadScene(Scene.Game)
    }

    onMatchmakingUpdate(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        this.uiManager?.matchmakingController.updateMatchmakingStatus(matchmakingStatusUpdate)
    }

    onMatchmakingError(error: BaseError) {
        this.uiManager?.matchmakingController.removePopups()
        showMatchmakingErrorPopup(error)
    }

    // eslint-disable-next-line class-methods-use-this
    onMatchmakingDisableAdblock() {
        const noContinueAction = () => undefined
        UIAdBlockController.showDisableAdblockPopup(noContinueAction, false, false)
    }

    // eslint-disable-next-line class-methods-use-this
    onChannelRoomUpdate(roomData: SocketDataTypes.ChannelRoomUpdate) {
        return
    }

    onRoomListUpdate(data: NetworkEnums.RoomListUpdateData) {
        this.uiManager?.lobby.updateRoomList(data)
    }

    // eslint-disable-next-line class-methods-use-this
    onEndGameText(data: any) {
        const playersJoinedRematch: number = data
        setGlobalGameEndNumberOfPlayersJoinedRematch(playersJoinedRematch)
    }
}
